var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "queryFormRef",
                  attrs: { model: _vm.queryParams, inline: "" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "name", $$v)
                          },
                          expression: "queryParams.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品条码", prop: "barcode" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.barcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "barcode", $$v)
                          },
                          expression: "queryParams.barcode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "业务类型", prop: "bizType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.queryParams.bizType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "bizType", $$v)
                            },
                            expression: "queryParams.bizType",
                          },
                        },
                        _vm._l(_vm.bizTypeOptions, function (item, i) {
                          return _c("el-option", {
                            key: "option_" + i,
                            attrs: { value: item.value, label: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作人", prop: "operator" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.queryParams.operator,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "operator", $$v)
                          },
                          expression: "queryParams.operator",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onQuery },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.onReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                height: "calc(100vh - 380px)",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "流水ID",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand", label: "商品品牌", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "goodsName", label: "商品名称", width: "350" },
              }),
              _c("el-table-column", {
                attrs: { prop: "spec", label: "商品规格", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "barcode", label: "商品条码", width: "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "convertQty",
                  label: "业务类型",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.bizTypeObj[scope.row.bizType]) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "changeQty",
                  label: "变动数量",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "afterQty",
                  label: "变动后",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "beforeQty",
                  label: "变动前",
                  width: "120",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "refBarcode", label: "关联商品", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.refBarcode || scope.row.refGoodsId
                          ? _c(
                              "el-row",
                              { staticClass: "my-column-row" },
                              [
                                scope.row.refBarcode
                                  ? _c("el-col", [
                                      _vm._v(
                                        "码: " + _vm._s(scope.row.refBarcode)
                                      ),
                                    ])
                                  : _vm._e(),
                                scope.row.refGoodsId
                                  ? _c("el-col", [
                                      _vm._v(
                                        "ID: " + _vm._s(scope.row.refGoodsId)
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "adminName", label: "操作人", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.adminName) +
                            " ( id: " +
                            _vm._s(scope.row.operator) +
                            " ) "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "备注信息",
                  "min-width": "300",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.updateTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mt16", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }